<template>
    <div class="photo-back">
        <!--文档图片-->
        <div class="img-box">
            <div class="prop-up"></div>
            <img src="@/assets/img/circle.png" class="circle" alt="">
        </div>
        <!--题目-->
        <div class="subject">
            <div>请在确认安全的情况下，完成以下小练习：</div>
        </div>
        <div class="task-wrap">{{ task }}</div>

        <div @click="checkBeans" class="check-btn">查看积分</div>
        <div @click="backToStart" class="check-btn back-btn" style="">{{ $t('back') }}</div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            // 任务
            task: '',
            countNumber: 0
        }
    },
    watch: {
        '$route': {
            immediate: true, // 组件创建时立即触发
            handler(newVal, oldVal) {
                this.$store.commit('SET_ANSWER_PERCENT', 100)
            }
        }
    },
    computed: {
        ...mapGetters([
            'userId',
        ]),
    },
    mounted() {
        this.getTask();
    },
    methods: {

        getTask() {
            this.task = localStorage.getItem('task')
        },

        /**
        * 查看积分页面
        */
        checkBeans() {
            this.$router.push('/end');
        },

        /**
         * 返回开始页
         */
        backToStart() {
            this.$router.push('/start');
        }

    }
};
</script>
<style scoped lang="less">
.photo-back {
    height: 100%;
}

.task-wrap {
    width: 90%;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 5px;
    box-sizing: border-box;
    margin: 20% auto;
    line-height: 30px;
}

.check-btn {
    position: absolute;
    bottom: calc(0.25 * var(--body-height));
    left: 50%;
    margin-left: -90px;
    width: 180px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #F6B122;
    color: #333333;
    border-radius: 10px;
    cursor: pointer;
}

.back-btn {
    bottom: calc(0.169 * var(--body-height));
    background: #3F75A8;
    color: #fff;
}
</style>